import { Component, inject, Input, signal } from '@angular/core';
import { NgbActiveModal } from 'node_modules/@ng-bootstrap/ng-bootstrap';
import { BranchWithBusiness, License, WithFormattedAddress } from 'src/model/business';
import { Company } from 'src/model/company.model';
import { CompanyService } from 'src/services/company.service';
import { SharedService } from '../Shared/shared-service.service';
import { ALERT_TYPE } from '../constants';

@Component({
  selector: 'app-change-business-branch',
  standalone: false,
  templateUrl: './change-business-branch.component.html',
  styleUrl: './change-business-branch.component.scss',
})
export class ChangeBusinessBranchComponent {
  private companyService = inject(CompanyService);
  private sharedService = inject(SharedService);
  private activeModal = inject(NgbActiveModal);

  @Input() currentBranch: BranchWithBusiness;
  @Input() activeLicense: WithFormattedAddress<License>;
  @Input() company: Company;

  // branchFullAddress = computed<string>(() => getFullAddress(this.currentBranch.Address));
  businessId = signal<number>(undefined);
  branchId = signal<number>(undefined);
  lockSelection = false;

  async changeBranch() {
    const c: Company = new Company(this.company.ID);
    c.CompanyCode = this.company.CompanyCode;
    c.DateOperating = this.company.DateOperating;
    c.BranchId = this.branchId();
    const result = await this.companyService.updateCompany(c);
    if (result.BranchId === this.branchId()) {
      this.sharedService.openAlert(`Branch changed successfully for ${this.company.CompanyCode}!`, ALERT_TYPE.SUCCESS, true);
    }
  }

  close() {
    this.activeModal.close();
  }
}
